import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { ReactComponent as Error } from "../../assets/icons/error.svg";
import { Button } from "@mui/material";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { BaseButtonStyle } from './../BaseButtonStyle';

const styleModal = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  bgcolor: "#FFFFFF",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

export const ButtonStyle = styled(BaseButtonStyle)({
  padding: "10px 48px",
});

export default function ModalErrorNIP({
  open = false,
  handleClose,
  handleModalError = () => {},
  timeLeftCountdown,
  handleOpenNIP,
  setPaused,
  handleServiceNIP,
  paused,
  setTimeLeftCountdown,
}) {
  useEffect(() => {
    if (timeLeftCountdown < 0 && !paused && open) {
      handleClose();
      handleServiceNIP();
      setTimeLeftCountdown(300);
    }
  }, [timeLeftCountdown, handleClose, handleServiceNIP, open, paused, setTimeLeftCountdown]);

  return (
    <Modal
      className="metricas-error"
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="metricas-error-nip" sx={styleModal}>
        <div className="flex flex-col items-center justify-center text-center space-y-4 text-[#313235] font-telefonica">
          <Error />
          <span className="text-md ">
            La solicitud del NIP no puede ser enviada de nuevo antes de{" "}
            {timeLeftCountdown} segundos
          </span>
          <ButtonStyle
            className="metricas-error-nip-continuar"
            onClick={() => {
              handleModalError();
              handleClose();
            }}
            fullWidth
            variant="contained"
            disableRipple
          >
            Entendido
          </ButtonStyle>
          <Button variant="text" onClick={handleOpenNIP}>
            <span className="underline lowercase text-blueDarkTelefonica">
              <span className="capitalize">Ya</span> tengo mi{" "}
              <span className="uppercase">NIP</span>
            </span>
          </Button>
        </div>
      </Box>
    </Modal>
  );
}